import React from 'react';
import Navbar from '../../components/navbar/index.jsx';
import Footer from '../../components/Footer/Footer.js';
import WaFloat from '../../components/WaFloat/WaFloat.jsx';
import { useReveal } from '../../hooks/useReveal.js';

const scrollTo = id => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

export default function Legal() {
  useReveal();
  return (
    <>
      <Navbar />

      <div className="legal-section">
        <div className="legal-max">
          <span className="sec-tag reveal">Legal</span>
          <h2 className="sec-h reveal" style={{ maxWidth: 520 }}>
            Privacy Policy, Terms of Use<br /><em>&amp; Refund Policy</em>
          </h2>
          <p className="reveal reveal-delay-1" style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.85, fontWeight: 300, marginTop: 16, maxWidth: 520 }}>
            By accessing our website, submitting enquiries, engaging our services, or communicating with us, you agree to the terms below. Please read them carefully.
          </p>

          <div className="legal-toc reveal reveal-delay-2">
            <button onClick={() => scrollTo('lt')} style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 4, padding: '8px 16px', fontSize: 12, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--muted)', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", transition: 'all .2s' }}>Terms of Use</button>
            <button onClick={() => scrollTo('lp')} style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 4, padding: '8px 16px', fontSize: 12, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--muted)', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", transition: 'all .2s' }}>Privacy Policy</button>
            <button onClick={() => scrollTo('lr')} style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 4, padding: '8px 16px', fontSize: 12, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--muted)', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", transition: 'all .2s' }}>Refund Policy</button>
          </div>

          {/* TERMS OF USE */}
          <div className="legal-s reveal" id="lt">
            <div className="legal-s-header"><span className="legal-s-title">Terms of Use</span></div>
            <div className="legal-clause">
              <h4>1. Independent Entity</h4>
              <p>AQT Direct Limited is an independent private entity providing business advisory, consulting, growth support, strategic introductions, and related professional services. We are not affiliated with any government authority, stock exchange, regulator, financial institution, or third-party brand unless explicitly stated in writing.</p>
            </div>
            <div className="legal-clause">
              <h4>2. Nature of Services</h4>
              <p>Our services may include business advisory, startup and MSME growth consulting, capital readiness support, strategic introductions, investor connect support, market expansion advisory, partner network opportunities, and fractional leadership engagements.</p>
              <div className="legal-highlight"><p>We do not guarantee loans, funding, investor interest, deal closure, approvals, profits, or timelines. All business decisions remain the sole responsibility of the client.</p></div>
            </div>
            <div className="legal-clause">
              <h4>3. No Regulated Financial Advice</h4>
              <p>AQT Direct Limited does not provide securities brokerage services, portfolio management services, stock recommendations, guaranteed investment returns, or regulated investment advisory activities unless through a separately licensed partner arrangement. Users should seek their own legal, tax, accounting, and licensed financial advice where required.</p>
            </div>
            <div className="legal-clause">
              <h4>4. Confidentiality</h4>
              <p>We handle shared information responsibly. Users should avoid sharing highly sensitive information before formal engagement documents are signed. Separate NDAs may be executed where required.</p>
            </div>
            <div className="legal-clause">
              <h4>5. User Submissions &amp; Prohibited Use</h4>
              <p>When you submit forms, messages, documents, or business information, you confirm the information is accurate, you have authority to share it, and it does not violate any law or third-party rights.</p>
              <div className="legal-highlight"><p>Unauthorized scraping, copying, spam submissions, or misuse of website data is strictly prohibited. Any such activity may result in immediate termination of access and legal action.</p></div>
            </div>
            <div className="legal-clause">
              <h4>6. Intellectual Property</h4>
              <p>All website content, branding, strategy material, text, design elements, frameworks, and business models displayed by AQT Direct Limited remain our intellectual property. No material may be copied, reproduced, sold, or reused without written permission.</p>
            </div>
            <div className="legal-clause">
              <h4>7. Limitation of Liability</h4>
              <p>AQT Direct Limited shall not be liable for business losses, missed opportunities, funding rejection, indirect damages, delays caused by third parties, or decisions taken by users based on discussions or content. Use of our website and services is at your own discretion.</p>
            </div>
            <div className="legal-clause">
              <h4>8. Third-Party Introductions</h4>
              <p>Our platform may involve introductions to investors, consultants, or strategic contacts. We do not guarantee outcomes, conduct, or performance of third parties. Users must independently evaluate all third-party opportunities.</p>
            </div>
            <div className="legal-clause">
              <h4>9. Changes to Terms</h4>
              <p>We may update this page at any time without prior notice. Continued use means acceptance of revised terms.</p>
            </div>
            <div className="legal-clause">
              <h4>10. Dispute Resolution &amp; Governing Jurisdiction</h4>
              <p>Any dispute shall first be attempted through mutual discussion. Failing resolution within 30 days, the matter shall be referred to arbitration or courts in India, as applicable.</p>
              <p>AQT Direct Limited's registered operating address: <strong>311, Sector 19, NMS Icon, Navi Mumbai, Ulwe, Panvel, Maharashtra, India – 410206.</strong></p>
            </div>
          </div>

          {/* PRIVACY POLICY */}
          <div className="legal-s reveal" id="lp">
            <div className="legal-s-header"><span className="legal-s-title">Privacy Policy</span></div>
            <div className="legal-clause">
              <h4>Information We Collect</h4>
              <p>We may collect name, email address, phone number, company details, and enquiry details you share with us.</p>
            </div>
            <div className="legal-clause">
              <h4>How We Use Your Information</h4>
              <p>For communication, service evaluation, internal records, and relevant business outreach. We do not sell personal data to third parties in the ordinary course of business.</p>
            </div>
            <div className="legal-clause">
              <h4>Third-Party Sharing</h4>
              <p>Information may be shared with our advisory team and partner professionals only as necessary to deliver our services. We do not share beyond what is required for service delivery.</p>
            </div>
            <div className="legal-clause">
              <h4>Contact for Privacy Queries</h4>
              <p>Email <a href="mailto:info@aqtdirect.com" style={{ color: 'var(--teal)' }}>info@aqtdirect.com</a> for any privacy-related concerns.</p>
            </div>
          </div>

          {/* REFUND POLICY */}
          <div className="legal-s reveal" id="lr">
            <div className="legal-s-header"><span className="legal-s-title">Refund Policy</span></div>
            <div className="legal-highlight">
              <p>All retainers, consulting fees, advisory fees, subscriptions, outcome fees, and any other payments made to AQT Direct Limited are strictly non-refundable.</p>
            </div>
            <div className="legal-clause" style={{ marginTop: 24 }}>
              <h4>No Exceptions</h4>
              <p>No refund will be issued under any circumstances — including cancellation, change of mind, internal delays, management decisions, or business outcome expectations. By making payment, the client acknowledges and accepts this policy. Any exception shall be solely at the written discretion of AQT Direct Limited.</p>
            </div>
            <div className="legal-clause">
              <h4>Basis of Engagement</h4>
              <p>All engagements are on an advisory and best-efforts basis. Fees paid are for professional time, expertise, introductions, and structured advisory support — not for guaranteed outcomes.</p>
            </div>
          </div>

          {/* CONTACT CARD */}
          <div className="legal-contact-card reveal">
            <div className="lcc-item"><div className="lcc-label">Company</div><div className="lcc-value">AQT Direct Limited</div></div>
            <div className="lcc-item"><div className="lcc-label">Legal &amp; Policy Email</div><div className="lcc-value"><a href="mailto:info@aqtdirect.com">info@aqtdirect.com</a></div></div>
            <div className="lcc-item"><div className="lcc-label">Registered Address</div><div className="lcc-value">311, Sector 19, NMS Icon<br />Navi Mumbai, Ulwe, Panvel<br />Maharashtra – 410206, India</div></div>
            <div className="lcc-item"><div className="lcc-label">Last Updated</div><div className="lcc-value">2025. Terms may be updated at any time. Continued use constitutes acceptance.</div></div>
          </div>
        </div>
      </div>

      <Footer />
      <WaFloat />
    </>
  );
}
